import { track } from "@amplitude/analytics-react-native";
import { useSearchParams } from "solito/navigation";
import { photo } from "src/api/amplitude/constants";
import native from "src/constants/native";
import { useGatheringStore } from "src/contexts/GatheringContext";
import useMountEffect from "src/hooks/useMountEffect";
import useRouter from "src/hooks/useRouter";

const usePhotoDetailTagTracking = (photoId: string) => {
	const searchParams = useSearchParams<{
		tag: string;
		userRef: string;
	}>();
	const router = useRouter();
	const identifier = useGatheringStore((state) => state.identifier);
	useMountEffect(() => {
		const isTag = searchParams?.get("tag") === "true";
		const userRef = searchParams?.get("userRef");
		if (isTag) {
			if (!native) {
				router.replaceState(`/album/${identifier}/photo`, {
					forwardParams: true,
					params: {
						tag: null,
						userRef: null,
					},
				});
			}
			track(photo.tagOpen, {
				photoId,
				userRef,
			});
		}
	}, [photoId]);
};
export default usePhotoDetailTagTracking;
